import { createApiClient, type ApiClient } from '@nyce/admin-kit/api';
import { BASE_URL, session } from '../session';
import { targetSession } from './session';

const clients = new Map<string, ApiClient>();

/**
 * The hub client for pages of one environment whose service the hub may call with the operator's own AUTH session:
 * adds that environment's session (if signed in) as `X-Target-Token`. The hub falls back to its own credential when
 * the service refuses it (automation gateway, print queue).
 */
export function targetHubClient(target: string): ApiClient {
  let c = clients.get(target);
  if (!c) {
    c = createApiClient({
      baseUrl: BASE_URL,
      auth: session,
      fetch: async (input, init = {}) => {
        const t = targetSession(target);
        const token = t.isSignedIn() ? await Promise.resolve(t.getToken()).catch(() => null) : null;
        if (!token) return globalThis.fetch(input, init);
        const headers = new Headers(init.headers);
        headers.set('X-Target-Token', token);
        return globalThis.fetch(input, { ...init, headers });
      },
    });
    clients.set(target, c);
  }
  return c;
}
